import React, { useState, useEffect } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import localStorageHelpers, {
  StorageKey,
} from "../storage/local-storage-helpers";
import { introspectToken } from "../networks/api-helper";
import LoadingSpinnerScreen from "src/libraries/components/loading-spinner/loading-spinner.screen";
interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>; // Component cần render nếu hợp lệ
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const token = localStorageHelpers.get(StorageKey.ACCESS_TOKEN);

  const [isValid, setIsValid] = useState<boolean | null>(null);
  const [loading, setLoading] = useState<boolean>(true); // Để chắc check valid đã chạy xong trước khi render
  const validate = async () => {
    if (token) {
      const valid = await introspectToken(token);
      console.log("Private route invalid token");

      setIsValid(valid);
    } else {
      setIsValid(false);
    }
    setLoading(false);
  };
  useEffect(() => {
    validate();
  }, [token]);
  if (loading) {
    return <LoadingSpinnerScreen className={"big"} />;
  }
  return (
    <Route
      exact
      {...rest}
      render={(props) =>
        isValid ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

export default PrivateRoute;
